export default {"src":"/_next/static/media/icon_vendor_analysis.abbb44c8.svg","height":22,"width":19,"blurWidth":0,"blurHeight":0};